<template>
    <v-avatar
        :class="[ backgroundClass, 'app-avatar', sizeClass ]"
        :size="small ? 25 : 40">
        {{ initials }}
    </v-avatar>
</template>

<script>
import styles from '@/services/styles'
import { mapGetters } from 'vuex';

export default {
    props: {
        staffMemberId: {
            type: Number,
            default: null,
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            getStaffMember: "data/getStaffMember"
        }),
        staffMember() {
            return this.getStaffMember(this.staffMemberId);
        },
        initials() {
            let name = this.staffMember?.name;
            if(name == null) {
                return;
            }
            let nameParts = name.split(" ");
            let initials = nameParts.map(n => n[0]);
            return initials.join("").toUpperCase();
        },
        backgroundClass() {
            return styles.getBackgroundColorClass(this.staffMemberId);
        },
        sizeClass() {
            return this.small ? "app-avatar--small" : null;
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/styles/theme.scss";

    .app-avatar{
        @include shadow;
        color: #fff;
        font-size: 1.1875rem;
    }

    .app-avatar--small {
        font-size: 0.75rem;
    }
</style>
